import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import Comments from '../../../Elements/Comments';
import AttachmentsComponent from '../../../Elements/AttachmentsComponent';
import IobDetailsInfoTab from './IobDetailsInfoTab';
import InvoicePdfPreviewComponent from '../../../Elements/InvoicePdfPreviewComponent';
import IobInvoiceViewDescription from './IobInvoiceViewDescription';
import IobInvoiceDetailsTab from './IobInvoiceDetailsTab';

export default class IobDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  iobId = this.urlParams.get('id');

  componentDidMount() {}

  tabs = [
    { label: 'Information', id: 'info', icon: 'fa-solid fa-info', component: <IobDetailsInfoTab /> },
    {
      label: 'Invoice View',
      id: 'invoiceviewreuse',
      icon: 'fa-solid fa-eye',
      component: (
        <InvoicePdfPreviewComponent
          id={this.iobId}
          invoiceDescription={IobInvoiceViewDescription}
          attachRoleKey='iob_createcreatelineitemmarkaspaidattachinvoicebutton'
          excelWordRoleKey='iob_downloadinvoicebutton'
        />
      )
    },
    {
      label: 'Invoice Details',
      id: 'invoicedetails',
      icon: 'fa-solid fa-file-invoice',
      component: <IobInvoiceDetailsTab />
    },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comments',
      component: <Comments entityTypeId={42} entityId={this.iobId} />
    },
    {
      label: 'Attachments',
      id: 'attachments',
      icon: 'fa-solid fa-paperclip',
      component: <AttachmentsComponent entityTypeId={42} entityId={this.iobId} enableAddNew={true} />
    }
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
